// Fire-and-forget telemetry for guided walkthrough events.
// Never throws — failures are silently dropped so telemetry can't break the UX.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-browser-tab session id — survives page navigations, resets on tab close.
function sessionId() {
  try {
    let sid = sessionStorage.getItem('wt_session_id');
    if (!sid) {
      sid = `wts_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
      sessionStorage.setItem('wt_session_id', sid);
    }
    return sid;
  } catch {
    return null;
  }
}

export function trackWalkthroughEvent({ guide_id, guide_title, step_index, total_steps, event }) {
  if (!guide_id || !event) return;
  try {
    axios.post(
      `${API}/telemetry/walkthrough-events`,
      { guide_id, guide_title, step_index, total_steps, event, session_id: sessionId() },
      { withCredentials: true, timeout: 4000 },
    ).catch(() => {}); // swallow all errors
  } catch {
    /* telemetry must never throw */
  }
}
